import React, { useState } from 'react';
import { truncateText } from '../edit/fields/utils';

interface CollapsibleReadMoreTextProps {
	/**
	 * The text to be collapsed if it's longer than the threshold
	 */
	text?: string;
	/**
	 * The threshold length at which collapsing will occur. Default is 50.
	 */
	collapseLength?: number;
	/**
	 * The text of the button to expand the text. Default is "Read More".
	 */
	readMoreText?: string;
	/**
	 * The text of the button to collapse the text. Default is "Read Less".
	 */
	readLessText?: string;
}

/**
 * Displays some text. If it's longer than the specified length (default 50 characters), it will collapse the text at that point
 * and display ellipsis, as well as a button to show the rest of the text.
 * @param param0
 */
export function CollapsibleReadMoreText({
	text,
	collapseLength = 50,
	readMoreText = 'Read More',
	readLessText = 'Read Less',
}: CollapsibleReadMoreTextProps) {
	const [showReadMore, setShowReadMore] = useState(true);

	if (!text) {
		return null;
	}

	return (
		<>
			<div>
				{showReadMore && text.length > collapseLength
					? truncateText(text, false, false, collapseLength, 14)
					: text}
			</div>
			{text.length > collapseLength && (
				<>
					<button onClick={() => setShowReadMore(!showReadMore)} className="roc-btn-link roc-btn--top-space">
						<strong>{showReadMore ? readMoreText : readLessText}</strong>
					</button>
				</>
			)}
		</>
	);
}
